export default __webpack_public_path__ + "static/media/next-to-last-pagination.a38bfe69.svg";